var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapProvider',{attrs:{"value":_vm.value}},[_c('svg',_vm._g(_vm._b({attrs:{"viewBox":("0 0 " + _vm.width + " " + _vm.height),"width":"100%","height":"100%"}},'svg',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }